import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';


@Component({
  selector: 'app-newAlerts',
  templateUrl: './newAlerts.component.html',
})
export class NewAlertsComponent implements OnInit {


  constructor(
    private _authorizeService: AuthorizeService) {

  }

  ngOnInit() {


  }

}
